import React from 'react';
import { classNames } from '../utils';

const Select = ({ className, defaultValue, items, placeholder, value, onValueChange, disabled }) => {
	return (
		<div className={classNames('flex items-center gap-x-4 border border-gray6 bg-white rounded-full h-10 w-full text-sm', className?.base || '')}>
			<select
				className={classNames('flex-1 outline-none border-none bg-transparent px-2 mr-2 w-full disabled:text-gray6', className?.select ? className.select : '')}
				placeholder={placeholder ?? 'Seleccione'}
				defaultValue={defaultValue}
				onChange={e => onValueChange(e.target.value)}
				value={value}
				disabled={disabled}
			>
				<option value="" disabled>{ placeholder ?? 'Seleccione' }</option>
				{items.map((item, index) => (
					<option key={index} value={item.value}>{ item.label }</option>
				))}
			</select>
		</div>
	);
}

export default Select;